import { makeServiceCall } from 'redux-core/serviceHelpers';
import { getCallAPI, deleteCallAPI } from 'utils/request';

/* QW-2408/QW-2409 resolver endpoints (technical plan §06). Phase 1 (pre-process + match)
   runs server-side right after /validate; /unmatched exposes the job status so callers
   can poll until it parks at AWAITING_RESOLUTION. */

export const getUnmatchedImportRowsCall = async ({ jobId }) =>
  getCallAPI({ path: `/clear/tracks-import/${jobId}/unmatched` });

export const resolveImportRowsCall = async ({ jobId, resolutions }) =>
  makeServiceCall('tracks-import', `${jobId}/resolve`, 'clear')({ resolutions });

export const getDivisionAliasesCall = async ({ jobId }) => {
  // Keyed on the resolver's own jobId; the backend reads the division off the job (persisted
  // server-side at /validate). No client-supplied division/production param to manipulate.
  const response = await getCallAPI({ path: `/clear/tracks-import/${jobId}/aliases` });
  return response?.aliases ?? [];
};

export const deleteTrackImportAliasCall = async ({ id }) =>
  deleteCallAPI({ path: `/clear/tracks-import/aliases/${id}` });
